module.exports = __webpack_public_path__ + "img/prove1.cf1cef35.png";